import { useSelector } from 'react-redux';

import type { FormattedProductBundle } from 'reducers/detail/productDetail';
import { getStyleByColor, hasHighlightsAccordionSection } from 'helpers/ProductUtils';
import { HIGHLIGHTS_ACCORDION_HEADING } from 'constants/product';
import useMartyContext from 'hooks/useMartyContext';
import { Accordion } from 'components/common/Accordion';
import { ProductCallout } from 'components/productdetail/ProductCallout';
import { selectSharedRewards } from 'selectors/rewards';

export interface HighlightsAccordionProps {
  colorId: string;
  productDetail?: FormattedProductBundle;
}

export const HighlightsAccordion = ({ colorId, productDetail }: HighlightsAccordionProps) => {
  const {
    marketplace: {
      pdp: { showProductCallout },
      hasRewardsTransparency
    }
  } = useMartyContext();
  const { transparencyPointsForItem } = useSelector(selectSharedRewards);
  const { brandPromos = [] } = transparencyPointsForItem || {};

  if (!productDetail) {
    return null;
  }

  const { styles, brandId } = productDetail;

  if (
    !hasHighlightsAccordionSection({
      colorId,
      styles,
      brandId,
      brandPromos,
      showProductCallout,
      hasRewardsTransparency
    })
  ) {
    return null;
  }

  const { taxonomyAttributes } = getStyleByColor(styles, colorId);

  return (
    <div data-test-id="highlightsAccordion">
      <Accordion heading={HIGHLIGHTS_ACCORDION_HEADING}>
        <ProductCallout brandId={brandId} brandPromos={brandPromos} attributes={taxonomyAttributes} />
      </Accordion>
    </div>
  );
};
